import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { HistorialDeCambiosComponent } from "src/app/proyectos/admin-proyectos/historial-de-cambios/historial-de-cambios.component";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { Riesgos } from "src/app/shared/model/gestion-proyectos/riesgos/riesgo.model";
import { Msg } from "src/app/utilerias/mensajes/Msg";

// Angular core y formularios
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Angular Material
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

import { MatDividerModule } from "@angular/material/divider";
import { ControlesRiesgoComponent } from "./controles-riesgo/controles-riesgo.component";
import { EvaluacionRiesgoComponent } from "./evaluacion-riesgo/evaluacion-riesgo.component";
import { DescripcionRiesgoComponent } from "./descripcion-riesgo/descripcion-riesgo.component";
import { MatStepperModule } from "@angular/material/stepper";

@Component({
  selector: "app-alta-riesgo-wizard",
  templateUrl: "./alta-riesgo-wizard.component.html",
  styleUrls: ["./alta-riesgo-wizard.component.css"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    MatDividerModule,
    ControlesRiesgoComponent,
    EvaluacionRiesgoComponent,
    DescripcionRiesgoComponent,
    MatStepperModule,
  ],
})
export class AltaRiesgoComponent implements OnInit {
  @Input() riesgoSeleccionado: Riesgos;
  @Input() esEditar: boolean;
  @Output() mostrarPrincipal = new EventEmitter<boolean>();
  @Output() mostrarMascaraConsulta = new EventEmitter<boolean>();
  primerGrupo: FormGroup;
  evaluacionRiesgoGroup: FormGroup;
  controlesRiesgoGroup: FormGroup;
  riesgo: Riesgos = new Riesgos();

  constructor(
    private _formBuilder: FormBuilder,
    private msg: Msg,
    public activeRouter: ActivatedRoute,
    private dialog: MatDialog,
    private service: ProyectosService
  ) {}

  ngOnInit() {
    this.initializeGroups();
    if (this.riesgoSeleccionado == null) {
      this.riesgo = new Riesgos();
    } else {
      this.riesgo = this.riesgoSeleccionado;
    }
    this.syncFormWithRisk();
    this.syncRiskWithForm();
  }

  initializeGroups() {
    this.primerGrupo = this._formBuilder.group({
      faseDeteccionCtrl: ["", [Validators.required]],
      descripcionCtrl: ["", [Validators.required]],
      causaRaizCtrl: ["", [Validators.required]],
    });
    this.evaluacionRiesgoGroup = this._formBuilder.group({
      probabilidadCtrl: ["", [Validators.required]],
      impactoCtrl: ["", [Validators.required]],
      estrategiaCtrl: ["", [Validators.required]],
    });
    this.controlesRiesgoGroup = this._formBuilder.group({
      fechaCtrl: ["", [Validators.required]],
      periodicidadCtrl: ["", [Validators.required]],
      accionesSeguirCtrl: ["", [Validators.required]],
      responsableRecursoCtrl: ["", [Validators.required]],
    });
  }

  private syncFormWithRisk(): void {
    this.primerGrupo.patchValue({
      faseDeteccionCtrl: this.riesgo.id_fase_deteccion ?? "",
      descripcionCtrl: this.riesgo.descripcion ?? "",
      causaRaizCtrl: this.riesgo.causa_raiz ?? "",
    }, { emitEvent: false });

    this.evaluacionRiesgoGroup.patchValue({
      probabilidadCtrl: this.riesgo.id_probabilidad ?? "",
      impactoCtrl: this.riesgo.id_impacto ?? "",
      estrategiaCtrl: this.riesgo.id_estrategia ?? "",
    }, { emitEvent: false });

    this.controlesRiesgoGroup.patchValue({
      fechaCtrl: this.riesgo.fecha_identificacion ?? "",
      periodicidadCtrl: this.riesgo.id_periodicidad ?? "",
      accionesSeguirCtrl: this.riesgo.acciones_seguir ?? "",
      responsableRecursoCtrl: this.riesgo.responsable_recurso ?? "",
    }, { emitEvent: false });
  }

  private syncRiskWithForm(): void {
    this.primerGrupo.valueChanges.subscribe((value) => {
      this.riesgo.id_fase_deteccion = value.faseDeteccionCtrl;
      this.riesgo.descripcion = value.descripcionCtrl;
      this.riesgo.causa_raiz = value.causaRaizCtrl;
    });

    this.evaluacionRiesgoGroup.valueChanges.subscribe((value) => {
      this.riesgo.id_probabilidad = value.probabilidadCtrl;
      this.riesgo.id_impacto = value.impactoCtrl;
      this.riesgo.id_estrategia = value.estrategiaCtrl;
    });

    this.controlesRiesgoGroup.valueChanges.subscribe((value) => {
      this.riesgo.fecha_identificacion = value.fechaCtrl;
      this.riesgo.id_periodicidad = value.periodicidadCtrl;
      this.riesgo.acciones_seguir = value.accionesSeguirCtrl;
      this.riesgo.responsable_recurso = value.responsableRecursoCtrl;
    });
  }

  guardar() {
    this.service.guardaRiesgo(this.riesgo).subscribe((res) => {
      if (res) {
        this.msg.successCall("Riesgo registrado con éxito", null, null);
        this.registroHistorialDCambios(this.riesgo.id);
        if (this.esEditar) {
          this.mostrarPrincipal.emit(true);
        }
      } else {
        this.msg.errorCall("Ocurrió un error", null, null);
      }
    });
  }
  registroHistorialDCambios(idTipo: number): void {
    let dialogRef = this.dialog.open(HistorialDeCambiosComponent, {
      disableClose: true,
      autoFocus: true,
      maxHeight: "900px",
      width: "1000px",
      panelClass: "custom-modalbox",
      data: { tipo_cambio: "RIESGO", id: idTipo },
    });
  }

  regresar() {
    this.mostrarPrincipal.emit(true);
  }
}
